export const API_DOMAIN = ['ci', 'test'].includes(process.env.MIX_ENV)
  ? 'localhost:4001'
  : process.env.API_DOMAIN;

export const API_PROTOCOL_SUFFIX = ['dev', 'ci', 'test'].includes(process.env.MIX_ENV) ? '' : 's';

export const AUTH0_CLIENT_ID = process.env.AUTH0_CLIENT_ID;

export const SOCKET_ENDPOINT = `ws${API_PROTOCOL_SUFFIX}://${API_DOMAIN}/socket`;

export const AUTH0_DOMAIN = process.env.AUTH0_DOMAIN;
